<template>
    <div :class="{'bg-greyLandmark': isCustomising}">
        <div class="container px-6">
            <div class="max-w-2xl mx-auto lg:max-w-6xl lg:px-3 py-8 lg:pt-12 lg:pb-20">
                <div :class="{'lg:flex': isEnquire}" id="enquire">
                    <div :class="{'lg:w-5/12': isEnquire}">
                        <slot name="breadcrumbs"></slot>
                        <h1 :class="firstLine.class">{{ firstLine.title }}<br><span class="second-line"
                                                                                    :class="secondLine.class"
                                                                                    v-if="secondLine.title">{{secondLine.title}}</span></h1>
                        <div :class="{'hidden': !isEnquire}">
                            <slot name="form" ></slot>
                        </div>
                    </div>
                    <div class="lg:w-7/12" v-if="isEnquire">
                        <div class="lg:ml-8">
                            <Summary
                                :product="product"
                                :customisationtype="customisationType"
                                :addOns="addOns"
                                :startOverEnabled="false"
                                :removeOptionEnabled="false"
                                :enquireOptionEnabled="false"
                                :viewProductEnabled="true"
                                @keep-editing="keepEditing"
                            ></Summary>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div v-if="!isEnquire" class="container px-6" id="options">
        <div class="max-w-2xl mx-auto lg:max-w-6xl lg:px-3 pb-20">
            <div v-if="!isCustomising" class="section-product-configurator-selector">
                <ConfiguratorPicker :landmarkavailable="product.landmarkavailable"
                                    :standardcustomisation="standardcustomisation"
                                    :landmarkcustomisation="landmarkcustomisation"
                                    @start="startCustomiser"
                                    @enquire="enquire"
                ></ConfiguratorPicker>
            </div>
            <div v-else>
                <Configurator class="section-product-configurator-options"
                              :product="product"
                              :customisationtype="customisationType"
                              :addOns="addOns"
                              :hubspotembed="hubspotembed"
                              :options="options"
                              :is-loading="isLoading"
                              @newAddOn="newAddOn"
                              @enquire="enquire"
                              @removeAddOn="removeAddOn"
                              @startOver="startOver"
                ></Configurator>
            </div>
        </div>
    </div>

    <teleport to="#blocks-product-configurator">
        <slot name="blocks" v-if="isEnquire"></slot>
    </teleport>

</template>


<script>
import ConfiguratorPicker from './product-configurator/configuratorPicker.vue'
import Configurator from './product-configurator/configurator.vue'
import {ref} from 'vue'
import Summary from "./product-configurator/summary";
import axios from "axios";

export default {
    name: "Twigwrapper",
    components: {
        Summary,
        ConfiguratorPicker,
        Configurator
    },
    props: {
        product: {
            required: true
        },
        hubspotembed: {
            required: false
        },
        productimage: {
            required: true
        },
        standardcustomisation: {
            // this is the blurb and header for the picker (standard div)
            required: true
        },
        landmarkcustomisation: {
            // this is the blurb and header for the picker (landmark div)
            required: true
        },
    },
    methods: {
        startCustomiser(customisationType) {
            this.isEnquire = false;
            this.isCustomising = true;
            this.firstLine = {title: "Start customising", class: "text-offBlack"};
            this.secondLine = {title: this.product.title + " " + customisationType, class: "text-gold"};

            this.customisationType = customisationType;
        },
        enquire(customisationType = null) {
            this.isEnquire = true;
            this.isCustomising = false;
            this.firstLine = {title: "My customisation details", class: "text-offBlack"};
            this.secondLine = {title: null, class: "text-offBlack"};

            if(customisationType) {
                this.customisationType = customisationType;
            }

            window.location.href = '#enquire';
        },
        keepEditing() {
            this.isEnquire = false;
            this.isCustomising = true;
            this.firstLine = {title: "Start customising", class: "text-offBlack"};
            this.secondLine = {title: this.product.title + " " + this.customisationType, class: "text-gold"};
        },
        newAddOn(addOn){
            this.addOns.push(addOn)
        },
        removeAddOn(addOnId) {
            const index = this.addOns.findIndex(x => x.id === addOnId);
            if (index > -1) {               // only splice array when item is found
                this.addOns.splice(index, 1);    // 2nd parameter means remove one item only
            }
        },
        startOver() {
            let confirmAction = confirm("Are you sure you want to remove all customisations?");
            if (confirmAction) {
                this.addOns = [];
            }
        },
        async getOptions() {
            let token = {
                [window.csrfTokenName]: window.csrfTokenValue
            }

            this.options = await axios.post(`/api/product-options`, {
                ...token,
                productid: this.product.id,
                productslug: this.product.slug,
                islandmark: this.customisationType === 'landmark' ? 1 : 0

            }).then((response) => {
                this.isLoading = false
                return response.data
            }).catch((response) => {
                console.log(response)
                this.isLoading = false
                return []
            })

        }
    },
    watch : {
        customisationType(newType, oldType) {
            if (newType?.length) {
                this.getOptions()
            }
        }
    },
    setup(props) {
        const isEnquire = ref(false)
        const isCustomising = ref(false)
        const customisationType = ref(null)
        const addOns = ref([]) // these are the selected add ons for the product
        const product = ref({
            id: props.product[0],
            title: props.product[1],
            url: props.product[2],
            price: props.product[3],
            slug: props.product[4],
            landmarkavailable: props.product[5],
            image: props.productimage,
        })
        const firstLine = ref({title: product.value.title, class: "text-offBlack"})
        const secondLine = ref({title: "customisation options", class: "text-offBlack"})
        const options = ref([])
        const isLoading = ref(true)

        return {
            firstLine,
            secondLine,
            product,
            addOns,
            isCustomising,
            isEnquire,
            options,
            isLoading,
            customisationType
        }
    },
}
</script>